import React, { useCallback } from "react";
import { connect } from "react-redux";
import { compose } from 'redux';
import { OAuthProviders, OAuthService } from '../../services/oauth';
import withAPI from '../../services/api';
import { debugLog } from '../../common/utils';
import cleverLoginButton from '../../assets/images/clever-login-button.svg';

const mapStateToProps = (state, ownProps?) => ({
  orgSettings: state.status.userOrgSettings,
});

const LoginWithCleverButton = ({api, orgSettings, linkToExisting}) => {

  function jsonToURI (json) {
    return encodeURIComponent(JSON.stringify(json));
  }

  const selectProviderFromSettings = () => {
    if (
      orgSettings &&
      orgSettings.default_sso_provider
    ) {
      if (orgSettings.default_sso_provider === 'clever_sso') {
        return new OAuthService(OAuthProviders.cleverSSOOnly);
      } else if (orgSettings.default_sso_provider === 'clever_securesync') {
        return new OAuthService(OAuthProviders.cleverSecureSync);
      }
    } else if (
      orgSettings.allowed_sso_providers.length > 0 && 
      orgSettings.allowed_sso_providers.includes('clever_securesync')
    ) {
      return new OAuthService(OAuthProviders.cleverSecureSync);
    } else {
      return new OAuthService(OAuthProviders.cleverSSOOnly);
    }
  };

  const handleCleverLogin = useCallback(async () => {
    if (linkToExisting) {
      try {
        debugLog("Linking to existing...")
        const provider = selectProviderFromSettings();
        api.createUserCode()
        .then((resp) => {
          const state = {
            link_to_existing: true,
            link_code: resp.usercode,
            slug: sessionStorage.getItem('authToken')
          }
          //debugLog("createUserCode returned:",resp);
          //debugLog("Redirecting with state:",state);
          //debugLog("Redirecting with state:",jsonToURI(state));
          provider.redirectToLogin({state:jsonToURI(state)})
        })
        .catch((e) => {
          console.error(e);
        });
      } catch (e) {
        console.error(e);
      };
    } else {
      try {
        var url = OAuthProviders.cleverSSOOnly.OAUTH_LOGIN_LAUNCH_PAGE
        debugLog("Redirecting to:",url);
        window.location.assign(url);
      } catch (e) {
        console.error(e);
      };
    };
  }, []);

  // On the login page, use Clever's own unaltered "Log in with Clever"
  // artwork. Clever ships complete buttons only (no standalone icon), so
  // the account-linking case in Settings keeps the local tile, whose label
  // is "Clever" rather than an invitation to log in.
  if (!linkToExisting) {
    return (
      <button id='login_with_clever_official'
        type="button"
        onClick={() => {handleCleverLogin()}}
      >
        <img src={cleverLoginButton} alt="Log in with Clever" />
      </button>
    );
  }

  return (
    <button id='login_with_clever'
      type="button"
      onClick={() => {handleCleverLogin()}}
    >
      <div className="a">
        <h2>C</h2>
      </div>
      <div className="b">
        Clever
      </div>
    </button>
  );
}

export default compose(connect(mapStateToProps), withAPI)(LoginWithCleverButton);
